import { AREA_DETAIL_FETCHING, AREA_DETAIL_FAILED, AREA_DETAIL_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case AREA_DETAIL_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case AREA_DETAIL_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case AREA_DETAIL_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
